import {Header} from '../util/header';
import {SwiperClass} from '../util/swiper';
import {Posts} from '../util/posts';

export default {
  init() {
    new Header();
    new SwiperClass();
    new Posts()
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./js/routes/common.js